import Text from '@helvetia/components/Text'
import dayjs from 'dayjs'
import * as React from 'react'
import { WithNamespaces, withNamespaces } from 'react-i18next'

import { getDefaultSelectedLanguage } from '../../../core/services/storage.service'
import {
  helvetiaGroup,
  impressum,
  jobs,
} from '../../_utils/environmentConst.provider'
import { goToLeaglInfo, goToPrivacyPolicyLink } from '../../_utils/links'
import {
  ContentLinksWrapper,
  FooterWrapper,
  LinksWrapper,
} from './Footer.styles'

const goToImpressum = () => {
  window.location.href = impressum[getDefaultSelectedLanguage()]
}

const goToJobs = () => {
  window.location.href = jobs[getDefaultSelectedLanguage()]
}

const goToHelvetiaGroup = () => {
  window.location.href = helvetiaGroup[getDefaultSelectedLanguage()]
}

const goToClimatePartner = () => {
  window.location.href =
    'https://fpm.climatepartner.com/tracking/12937-1809-1001/en'
}

const Footer: React.SFC<WithNamespaces> = ({ t }) => (
  <FooterWrapper>
    <ContentLinksWrapper>
      <LinksWrapper onClick={goToJobs}>Jobs</LinksWrapper>
      <LinksWrapper onClick={goToHelvetiaGroup}>
        {t('footer.helvetiaGroup')}
      </LinksWrapper>
      <LinksWrapper onClick={goToClimatePartner}>ClimatePartner</LinksWrapper>
    </ContentLinksWrapper>
    <div>
      <Text as="div" color="grayDark" size="xsBold">
        {t('footer.helvetia')}
      </Text>
      <Text as="div" color="grayDark" size="xxs">
        {`© ${dayjs(new Date()).year()} ${t('footer.helvetiaAddress')}`}
        <span style={{ marginLeft: '20px' }} />

        <LinksWrapper onClick={goToImpressum}>{t('footer.print')}</LinksWrapper>

        <LinksWrapper onClick={goToLeaglInfo}>{t('footer.legal')}</LinksWrapper>

        <LinksWrapper onClick={goToPrivacyPolicyLink}>
          {t('footer.privacyPolicy')}
        </LinksWrapper>
      </Text>
    </div>
  </FooterWrapper>
)

export default withNamespaces()(Footer)
